module.exports = __webpack_public_path__ + "static/media/accordianHandler.b656ec62.svg";